import React, { Component } from "react";

export default class ServicesSection extends Component {
  render() {
    return (
      <section className="page-section" id="services">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <h2 className="section-heading text-uppercase">Services</h2>
              <h3 className="section-subheading text-muted">
                That's what I Can Do{" "}
              </h3>
            </div>
          </div>
          <div className="row text-center">
            <div className="col-md-4">
              <span className="fa-stack fa-4x">
                <i className="fas fa-circle fa-stack-2x text-primary"></i>
                <i className="fas fa-laptop fa-stack-1x fa-inverse"></i>
              </span>
              <h4 className="service-heading">Front-End</h4>
              <p className="text-muted">
                With Front-End Skills Like
                <strong> HTML</strong>,<strong> CSS </strong>,
                <strong> JavaScript ES6 </strong> and
                <strong> ReactJS </strong>I can create Client Side of Website
              </p>
            </div>
            <div className="col-md-4">
              <span className="fa-stack fa-4x">
                <i className="fas fa-circle fa-stack-2x text-primary"></i>
                <i className="fas fa-code fa-stack-1x fa-inverse"></i>
              </span>
              <h4 className="service-heading">Back-End</h4>
              <p className="text-muted">
                With Back-End Skills Like
                <strong> NodeJS</strong>,<strong> ExpressJS </strong>,
                <strong> MongoDB </strong>, and
                <strong> MySQL </strong>I can create Server Side of Website or
                Mobile Application{" "}
              </p>
            </div>
            <div className="col-md-4">
              <span className="fa-stack fa-4x">
                <i className="fas fa-circle fa-stack-2x text-primary"></i>
                <i className="fas fa-mobile fa-stack-1x fa-inverse"></i>
              </span>
              <h4 className="service-heading">Mobile Application </h4>
              <p className="text-muted">
                With Cross-Platform Application Development using{" "}
                <strong> React Native </strong> I can Create a Mobile App for
                both <strong>Android & iOS</strong>{" "}
              </p>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
